export const fr = {
    logout: "le logout",
    viewpoint: {
        name: "Point de vue IA"
    },
    titles: {
        settings: "Réglages"
    },
}